// eslint-disable-next-line import/no-anonymous-default-export
export default {
  coeToDoWork: {
    entityTypeName: "待处理的",
    name: "工单名称",
    introduction: "展示提交给自动化卓越中心的所有需求列表",
  },
};
